import {connect} from "react-redux";
import StockPanelSet from "./StockPanelSet";
import * as InventoryApiActions from "../../actions/InventoryApiActions";
import * as SelectionActions from "../../actions/SelectionActions";
import * as ViewActions from "../../actions/ViewActions";
import {getSelection} from "../../reducers/selectionReducer";
import {getWarehouses, getStockWarehouseFilter} from "../../reducers/inventoryReducer";

function mapStateToProps(state) {
  const context = "stock";
  const selection = getSelection(state.get("selection"), context);  
  return {
    context: context,
    warehouses: getWarehouses(state.get("inventory")),
    // selectedProduct: getProductWithId(state.get("inventory"), selection),
    stockWarehouseFilter: getStockWarehouseFilter(state.get("inventory")),
    selection: selection,
    hasSelection: selection !== ""
  }
}

export default connect(mapStateToProps, {...InventoryApiActions, ...SelectionActions, ...ViewActions})(StockPanelSet);